import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getVaidationErrors';
import Buttom from '../../forms/Buttom';
import Input from '../../forms/Input';
import Modal from '../Modal';
import { createStudent } from '../../../services/api';
import { Container, Bottom, Row, Both } from './styles';

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  clearFilter: () => void;
  lmsKey: string | null;
}

const ModalAddStudent: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  clearFilter,
  lmsKey,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async data => {
      if (!lmsKey) {
        addToast({
          title: 'Erro',
          type: 'error',
          description: 'Chave LMS não encontrada. Faça login novamente.',
        });
        return;
      }
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome é obrigatório'),
          email: Yup.string().required('Identificador de acesso é obrigatório'),
          course: Yup.string().required('Curso é obrigatório'),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        await createStudent(lmsKey, {
          name: data.name,
          email: data.email,
          course: data.course,
        });

        clearFilter();
        addToast({
          title: 'Aluno cadastrado com sucesso!',
          type: 'success',
        });
        setIsOpen();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          title: 'Ops...',
          type: 'error',
          description:
            (error as any)?.response?.data?.message || 'Algo inesperado aconteceu.',
        });
      } finally {
        setLoading(false);
      }
    },
    [lmsKey, addToast, setIsOpen, clearFilter],
  );

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Container>
        <h1>Novo Aluno</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Row>
            <Input
              name="name"
              label="Nome:"
              type="text"
              placeholder="Nome completo"
            />
          </Row>
          <Row>
            <Input
              name="email"
              label="Identificador de acesso:"
              type="text"
              placeholder="Ex.: email, CPF, matrícula..."
            />
          </Row>
          <Row>
            <Input
              name="course"
              label="Curso:"
              type="text"
              placeholder="Ex.: Ciências da Computação"
            />
          </Row>
          <Both />
          <button type="submit" hidden>
            submeter
          </button>
        </Form>
        <Bottom>
          <Buttom
            name="cancelar"
            type="button"
            onClick={() => setIsOpen()}
            label="Cancelar"
            outline
          />
          <Buttom
            name="salvar"
            onClick={() => formRef.current?.submitForm()}
            label="Salvar"
            isLoading={loading}
          />
        </Bottom>
      </Container>
    </Modal>
  );
};

export default ModalAddStudent;
